const fullscreenMode = (editor,setRunFullScreen) => {

    if (editor.BlockManager !== undefined) {
        const commands = editor.Commands;
        editor.on('run:command-fullscreen', () => {
          if (commands.isActive('view-annotations') === false) {
            setRunFullScreen(true);
            editor.refresh();
          }
        });
        editor.on('stop:command-fullscreen', () => {
          if (commands.isActive('view-annotations') === false) {
            setRunFullScreen(false);
            editor.refresh();
          }
        });
    }

}

export default fullscreenMode
